var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.25716 5.82851L0.0141602 1.58551L1.42916 0.171509L4.25716 3.00051L7.08516 0.171509L8.50016 1.58551L4.25716 5.82851Z"}));
}

ChevronDown.defaultProps = {"width":"9","height":"6","viewBox":"0 0 9 6","fill":"currentColor"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
